function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("circle", {
  id: "path-1-chatWithUs",
  cx: 85,
  cy: 85,
  r: 85
}), React.createElement("linearGradient", {
  x1: "31.4497058%",
  y1: "24.1596461%",
  x2: "71.9797545%",
  y2: "80.6164263%",
  id: "linearGradient-3-chatWithUs"
}, React.createElement("stop", {
  stopColor: "#6EC18A",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#0E89CA",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "21.3173604%",
  y1: "24.6717038%",
  x2: "83.9853034%",
  y2: "80.0097249%",
  id: "linearGradient-4-chatWithUs"
}, React.createElement("stop", {
  stopColor: "#6EC18A",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#0E89CA",
  offset: "100%"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "UX-+-UI-chatWithUs",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "02-desktop-UI-chatWithUs",
  transform: "translate(-1210.000000, -1014.000000)"
}, React.createElement("g", {
  id: "Icon-chatWithUs",
  transform: "translate(1210.000000, 1014.000000)"
}, React.createElement("mask", {
  id: "mask-2-chatWithUs",
  fill: "white"
}, React.createElement("use", {
  xlinkHref: "#path-1-chatWithUs"
})), React.createElement("use", {
  id: "Forma-chatWithUs",
  fill: "#F0F0F0",
  xlinkHref: "#path-1-chatWithUs"
}), React.createElement("text", {
  id: "Chatta-con-noi-chatWithUs",
  fontFamily: "Helvetica",
  fontSize: 18,
  fontWeight: "normal",
  letterSpacing: 0.2,
  fill: "#2798B9"
}, React.createElement("tspan", {
  x: 25.5614258,
  y: 136
}, "Chatta con noi")), React.createElement("g", {
  transform: "translate(46.000000, 30.000000)"
}, React.createElement("path", {
  d: "M10.4562399,63.6823427 C2.01732709,58.8649012 15.4701706,17.5145631 38.5631415,17.5145631 C61.6523112,17.5145631 61.6523112,70.620217 38.5631415,70.620217 C32.8535708,70.620217 27.3986879,69.8767379 22.4531809,68.5680628 L4.02061856,82 L10.4562399,63.6823427 Z",
  id: "Forma-chatWithUs",
  stroke: "url(#linearGradient-3)",
  strokeWidth: 0.64,
  fill: "url(#linearGradient-3-chatWithUs)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("ellipse", {
  id: "Forma-chatWithUs",
  fill: "url(#linearGradient-4-chatWithUs)",
  fillRule: "nonzero",
  cx: 39,
  cy: 38.6116505,
  rx: 39,
  ry: 38.6116505
}), React.createElement("g", {
  id: "Logo-chatWithUs",
  transform: "translate(19.000000, 20.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "Group-chatWithUs"
}, React.createElement("g", null, React.createElement("g", {
  transform: "translate(0.000000, 8.810693)",
  id: "Path-chatWithUs"
}, React.createElement("path", {
  d: "M8.98894772,21.3218767 L11.0255062,15.4363339 L6.32035386,1.86786688 C5.86388386,0.7400982 4.77537847,6.9388939e-18 3.58153386,0.0352427714 L3.30062924,0.0352427714 C1.2289577,0.0352427714 -0.210678462,2.14980906 0.561809232,4.08816148 L8.91872156,22.5201309 C8.81338233,22.1324604 8.84849541,21.74479 8.98894772,21.3218767 Z"
}), React.createElement("path", {
  d: "M18.7152701,0.0352427714 L18.4343654,0.0352427714 C17.2405208,0.0352427714 16.1520154,0.775340971 15.6955454,1.90310966 L15.5902062,2.14980906 L11.0255062,15.4363339 L13.0620647,21.3218767 C13.23763,21.74479 13.23763,22.1677032 13.1674039,22.5553737 L18.5748177,10.4671031 L21.418977,4.08816148 C22.2265778,2.11456628 20.7869416,1.38777878e-17 18.7152701,0.0352427714 Z"
}), React.createElement("path", {
  d: "M13.0620647,21.3218767 L11.0255062,15.4363339 L8.98894772,21.3218767 C8.81338233,21.74479 8.81338233,22.1677032 8.88360849,22.5201309 L9.02406079,22.8373159 C9.30496541,23.5774141 10.0072269,24.0708129 10.7797146,24.1412984 C10.8148277,24.1412984 10.8148277,24.1412984 10.8499408,24.1412984 C10.8850539,24.1412984 10.920167,24.1412984 10.95528,24.1412984 L11.0957323,24.1412984 C11.1308454,24.1412984 11.1659585,24.1412984 11.2010716,24.1412984 C11.2361846,24.1412984 11.2361846,24.1412984 11.2712977,24.1412984 C12.0437854,24.0708129 12.7109339,23.5774141 12.9918385,22.8373159 L13.1322908,22.5201309 C13.2727431,22.1324604 13.23763,21.7095472 13.0620647,21.3218767 Z"
})), React.createElement("ellipse", {
  id: "Ova-chatWithUsl",
  cx: 21.8403339,
  cy: 3.4537916,
  rx: 3.40596847,
  ry: 3.41854883
})), React.createElement("path", {
  d: "M28.4415924,30.379269 L26.2645816,24.211784 L24.1929101,30.0268412 C24.0524578,30.379269 24.0173447,30.7316967 24.0524578,31.0841244 C24.0524578,31.1898527 24.0875708,31.3308238 24.1226839,31.4717949 C24.1226839,31.4717949 24.6844931,32.9167485 26.1943555,32.9167485 C26.3348078,32.9167485 26.5103731,32.9167485 26.5454862,32.9167485 C27.353087,32.846263 28.0202355,32.3528642 28.3362532,31.5775232 C28.3011401,31.5775232 28.6171578,30.8021822 28.4415924,30.379269 Z",
  id: "Path-chatWithUs"
}), React.createElement("path", {
  d: "M33.9192324,8.81069285 L33.6383278,8.81069285 C32.4444832,8.81069285 31.3559778,9.55079105 30.8995078,10.6785597 L30.7941685,10.9252591 L26.2294685,24.211784 L28.266027,30.0973268 C28.4415924,30.52024 28.4415924,30.9431533 28.3713662,31.3308238 L33.7787801,19.2425532 L36.6229393,12.8636116 C37.4305401,10.8900164 35.9909039,8.77545008 33.9192324,8.81069285 Z",
  id: "Path-chatWithUs"
}), React.createElement("ellipse", {
  id: "Oval-chatWithUs",
  cx: 37.0442963,
  cy: 3.41854883,
  rx: 3.40596847,
  ry: 3.41854883
}), React.createElement("path", {
  d: "M24.157797,30.0973268 L26.2294685,24.211784 C24.4387016,19.1368249 22.0158993,12.3702128 21.5243162,10.9252591 C21.6998816,11.5243863 21.6998816,12.1939989 21.4540901,12.8636116 L18.6099308,19.2425532 L24.1226839,31.4717949 C23.9822316,31.0488816 23.9822316,30.5554828 24.157797,30.0973268 Z",
  id: "Path-chatWithUs"
})))))));

var SvgChatWithUsIcon = function SvgChatWithUsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 170 170",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChatWithUsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chatWithUsIcon.76cadf49.svg";
export { ForwardRef as ReactComponent };